import { render, staticRenderFns } from "./TextSettings.vue?vue&type=template&id=7dbcebac&scoped=true"
import script from "./TextSettings.vue?vue&type=script&lang=ts"
export * from "./TextSettings.vue?vue&type=script&lang=ts"
import style0 from "./TextSettings.vue?vue&type=style&index=0&id=7dbcebac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbcebac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbcebac')) {
      api.createRecord('7dbcebac', component.options)
    } else {
      api.reload('7dbcebac', component.options)
    }
    module.hot.accept("./TextSettings.vue?vue&type=template&id=7dbcebac&scoped=true", function () {
      api.rerender('7dbcebac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/TextSettings.vue"
export default component.exports